var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiringModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4332_15272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8387 15.7819H15.2719V23.25H11.8387V15.7819Z",
    fill: "#C87D5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2719 17.6681C14.9644 17.1693 14.5575 16.7437 14.0437 16.4662C13.725 16.2937 13.3725 16.1943 13.0144 16.1587H12.4162C12.2212 16.1774 12.0262 16.2149 11.8387 16.2712V20.0456C12.0056 19.7906 12.2831 19.6068 12.5831 19.5356C13.1062 19.4137 13.6612 19.6143 14.085 19.9424C14.5087 20.2706 14.8256 20.7168 15.135 21.1537L15.2737 21.3487V17.6681H15.2719Z",
    fill: "#874D36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42624 5.43188C7.64999 5.43188 9.45936 6.93564 9.45936 8.78626V17.7113H1.39124V8.78626C1.39124 6.93564 3.20061 5.43188 5.42624 5.43188Z",
    fill: "#4E342E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3069 17.6607H3.58687C3.1875 17.6607 2.85 17.3663 2.79562 16.9707L1.85062 10.1026C1.84004 10.0252 1.84616 9.94651 1.86855 9.87173C1.89094 9.79694 1.92909 9.72782 1.98043 9.66902C2.03177 9.61022 2.09511 9.5631 2.16619 9.53083C2.23727 9.49855 2.31444 9.48188 2.3925 9.48193H10.3069V17.6607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2906 4.70435H5.42624C5.42624 4.70435 9.84749 5.24622 9.84749 8.97559L9.86999 18.4406H22.3425C22.8431 18.4406 23.2481 18.0356 23.2481 17.535V9.66372C23.25 6.92435 21.03 4.70435 18.2906 4.70435Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6506 6.37689L14.1244 6.42939L11.9025 9.83814V7.07251C11.9025 5.59501 10.4025 4.70251 10.4025 4.70251H16.245L16.275 4.73251C16.8881 5.31564 16.4962 6.34689 15.6506 6.37689Z",
    fill: "#0D47A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9144 11.8537C14.7573 11.8537 15.4406 11.0847 15.4406 10.1362C15.4406 9.18765 14.7573 8.4187 13.9144 8.4187C13.0714 8.4187 12.3881 9.18765 12.3881 10.1362C12.3881 11.0847 13.0714 11.8537 13.9144 11.8537Z",
    fill: "#0D47A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5419 1.89562L12.5475 9.68812C12.5475 9.95062 12.7594 10.1625 13.0219 10.1625H13.98C14.2425 10.1625 14.4544 9.95062 14.4544 9.68812V0.75H13.6856C13.5353 0.75 13.3864 0.779646 13.2475 0.837242C13.1086 0.894838 12.9824 0.979254 12.8762 1.08566C12.77 1.19206 12.6858 1.31837 12.6284 1.45735C12.571 1.59634 12.5416 1.74527 12.5419 1.89562Z",
    fill: "#C62828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.96 1.89562L12.9656 9.68812H14.4975V3.65438H17.1375C17.7469 3.65438 17.8181 3.39 17.8181 2.23875C17.8181 1.0875 17.7487 0.75 17.1394 0.75H14.1037C13.9534 0.75 13.8045 0.779646 13.6656 0.837242C13.5267 0.894838 13.4006 0.979254 13.2943 1.08566C13.1881 1.19206 13.1039 1.31837 13.0465 1.45736C12.9891 1.59634 12.9597 1.74527 12.96 1.89562Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9481 2.04001C13.935 2.41314 13.6913 5.79189 13.6481 6.42564C13.5956 7.19251 13.1531 7.27126 13.1531 6.57376V2.00626C13.155 1.26751 13.9763 1.22814 13.9481 2.04001Z",
    fill: "#FF7555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7625 7.95744L13.7756 11.3906H12.9994C12.24 11.3906 11.625 10.6218 11.625 9.67307C11.625 8.72432 12.24 7.95557 12.9994 7.95557C13.7588 7.95557 13.7625 7.95744 13.7625 7.95744Z",
    fill: "#82AEC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7625 11.3906C14.5215 11.3906 15.1369 10.6216 15.1369 9.67307C15.1369 8.72452 14.5215 7.95557 13.7625 7.95557C13.0035 7.95557 12.3881 8.72452 12.3881 9.67307C12.3881 10.6216 13.0035 11.3906 13.7625 11.3906Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9413 9.72376C13.0238 9.76501 13.1231 9.72001 13.1944 9.66001C13.4119 9.47813 13.4944 9.17813 13.695 8.97938C13.8713 8.80313 14.1394 8.63063 13.9294 8.37001C13.7775 8.18251 13.5206 8.21439 13.32 8.30064C12.8756 8.48626 12.5231 9.51376 12.9413 9.72376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42625 5.4806C7.63313 5.4806 9.42938 6.9731 9.42938 8.80872V17.6625H1.42313V8.80685C1.42313 6.9731 3.21938 5.4806 5.42625 5.4806ZM5.42625 4.70435C2.58938 4.70435 0.75 6.61497 0.75 8.97372V18.0393C0.75 18.2587 0.928125 18.4387 1.14938 18.4387H10.1663C10.3856 18.4387 10.5656 18.2606 10.5656 18.0393V8.97372C10.5619 6.61497 8.26313 4.70435 5.42625 4.70435Z",
    fill: "#4FC3F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.31499 17.1563C3.20437 17.0982 3.29624 16.9875 3.35812 16.8863L5.86499 12.5194L6.35812 12.8194L3.56812 17.0157C3.49687 17.1244 3.42562 17.2144 3.31499 17.1563Z",
    fill: "#6FBFF0",
    stroke: "#6FBFF0",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47937 14.0494L2.27812 10.0556C2.21437 10.0125 2.16 9.93373 2.22562 9.85498C2.27812 9.79123 2.32687 9.82497 2.41875 9.87935L7.45875 13.3519C7.58625 13.4306 7.75125 13.3968 7.83937 13.2768L9.34312 11.2406L9.33937 12.1537L8.07187 13.9425C8.00607 14.0334 7.90762 14.0953 7.79715 14.1153C7.68669 14.1352 7.5728 14.1116 7.47937 14.0494Z",
    fill: "#6FBFF0",
    stroke: "#6FBFF0",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4332_15272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiringModalIcon);
export default __webpack_public_path__ + "static/media/hiring_modal_icon.9be66cabe5cc91f155eabcdbe38b15d5.svg";
export { ForwardRef as ReactComponent };